
import { Options, Prop, Vue } from 'vue-property-decorator'

import RtlPlus from '../icons/RtlPlus.vue'

@Options({
  name: 'UefaPlayerTable'
})
export default class UefaPlayerTable extends Vue {
  @Prop({
    type: String
  })
  readonly title!: string

  @Prop({
    type: Array,
    default: () => []
  })
  readonly contents!: Array<{
    name: string
    img?: string
    team?: string
    value: number
  }>
}
